document.addEventListener('DOMContentLoaded', function() {
  // Menu accordions
  var accordionHeaders = document.getElementsByClassName('js-footer-navigation-title');

  for (var i = 0; i < accordionHeaders.length; i++) {
    accordionHeaders[i].addEventListener('click', toggleAccordion);
  }

  function toggleAccordion() {
    // var accordionContent = this.nextElementSibling;

    if (this.classList.contains('active')) {
      this.classList.remove('active');
    } else {
      this.classList.add('active');
    }
  }
});
